<template>
  <div :class="[brandClasses.container, { 'o:hidden': upsellIdsInCart.length === upsells.length }]">
    <h2 v-if="title" :class="brandClasses.title">
      {{ title }}
    </h2>
    <p v-if="subtitle" :class="brandClasses.subtitle">
      {{ subtitle }}
    </p>
    <div :class="brandClasses.upsellsWrapper">
      <product-bundled-upsell
        v-for="upsell in upsells"
        :key="upsell.id"
        :class="{ 'o:hidden': upsellIdsInCart.includes(upsell.id) }"
        data-test-id="product-bundled-upsell"
        :selection="bundleSelection.find(({ product }) => product.id === upsell.id)"
        :upsell
        @open-quickshop="$emit('openQuickshop', $event)"
        @rec-click="(id, action) => $emit('recClick', id, action)"
        @remove="$emit('remove', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Product } from '#root/api/clients/product/data-contracts'
import type { ProductClickAction } from '#types/gtm'
import type { BundleSelectionItem, ProductUpsell } from '#types/product'

export type Props = {
  bundleSelection?: BundleSelectionItem[]
  subtitle?: string
  title?: string
  upsells: ProductUpsell[]
}

export type Emits = {
  openQuickshop: [product: Product]
  recClick: [id: string, action?: ProductClickAction]
  remove: [id: string]
}

const { bundleSelection = [], subtitle, title, upsells } = defineProps<Props>()
defineEmits<Emits>()

const { brandClasses } = useAppConfig().components.product.bundledUpsells
const cart = useCartStore()

const upsellIdsInCart = computed(() => upsells
  .filter(({ id }) => cart.items.find(({ masterId, masterId2 }) => id === masterId || id === masterId2))
  .map(({ id }) => id)
)
</script>
